<template>
  <div class="other" id='id'>
    <img class="hand-img" v-lazy="img.member_bg">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="message">
        <div class="info">
          <div class="head_box">
           <img class="head" :src="otherinfo.avatar&&otherinfo.avatar.substring(0,5)=='https' ? otherinfo.avatar : img.avatar">
           <img class="head_border" :src="img.border_pic" v-if="otherinfo.auth.is_audit==1">
         </div>
         
         <span v-if="user">
          <van-button class="follow buttonin" icon="plus" color="#3a3a3a" v-if="info.is_follow==0&&info.id!=user.id" size="small"  @click="follow(info.is_follow)">关 注</van-button>
          <van-button class="followd buttonin" size="small" v-if="info.is_follow==1&&info.id!=user.id" @click="follow(info.is_follow)">已关注</van-button>
          <van-button class="followd buttonin" size="small" v-if="info.is_follow==2&&info.id!=user.id" @click="follow(info.is_follow)">互相关注</van-button>
        </span>
        <span v-else>
          <van-button class="follow buttonin" icon="plus" color="#3a3a3a" size="small"  @click="follow(info.is_follow)">关 注</van-button>
        </span>
        <div class="f-13 f-w c-black ml-20">{{otherinfo.username}}</div>
        <div class="f-12 c-gray ml-20" style="display:flex" v-if="otherinfo.auth.is_audit==1">
          <img class="member_car" style="padding-top: 5px;" :src="otherinfo.auth.pic">
          <div style="flex: 1;">
            <div v-for="(item,index) in otherinfo.auth.title" :key="'approve_'+index">
              {{item}}
            </div>
          </div>
        </div>
        <div class="f-12 c-gray ml-20" v-if="otherinfo.cars"><img class="member_car" :src="img.member_car">{{otherinfo.cars.title}} 车主</div>
        <div class="f-12 c-gray ml-20" v-if="otherinfo.intro">{{otherinfo.intro}}</div>
        <div class="f-12 c-gray ml-20" v-else>这个家伙很懒，什么都没有留下~</div>
        <div class="f-14 f-w c-black ml-20" hidden="true">
          <span class="f-14 f-w c-black">座驾</span>
          <span class="f-14 f-w c-gray ml-10">雷克萨斯UX 260h 探酷版</span>
        </div>
        <van-row class="ml-20 mt-10">
          <van-col span="8" @click="myPraise">
            <span class="c-gray">获赞</span><span class="f-w c-black ml-10">{{info.praise_num}}</span>
          </van-col>
          <van-col span="8" @click="fans(0)">
            <span class="c-gray">关注</span><span class="f-w c-black ml-10">{{info.follow_num}}</span>
          </van-col>
          <van-col span="8" @click="fans(1)">
            <span class="c-gray">粉丝</span><span class="f-w c-black ml-10">{{info.fans_num}}</span>
          </van-col>
        </van-row>
      </div>
    </div>
     <!--  <van-tabs class="mt-10" v-model="active" color="#3A3A3A" title-active-color='#3A3A3A' title-inactive-color="#9a9a9a" @click="onClick">
      <van-tab title="动态"> -->
        <div class="listleft">
          <div class="years">{{nowyear}}</div>
          <van-row v-if="finished">
            <van-col span="6">
              <div class="today">{{nowdata}}</div>
              <div class="location"></div>
            </van-col>
          </van-row>
          <van-list
          v-model="loading"
          :finished="finished"
          finished-text="已加载全部"
          :offset='580'
          @load="onLoad"
          >
          <div slot="loading" class="list-loading">
            <img :src="img.loading" />
          </div>
          <div v-for="(item,index) in list" :key="'space_'+item.id">
            <div class="years" v-if="item.yearshow">{{item.years}}</div>
            
            <van-row v-if="item.cate.id==1">
              <van-col span="6">
                <div class="today" v-if="item.mon!=nowdata&&item.monshow">{{item.mon}}</div>
                <div class="location"></div>
              </van-col>
              <van-col span="18">
                <div class="content">
                  <div class="typetime"><span>{{item.cate.type}}</span>-{{item.mon}}</div>
                  <p class="title" @click="goInfo(item.cate.id,item.id)">{{item.title}}</p>
                  <span class="ellipsis-4 fonts" @click="goInfo(item.cate.id,item.id)">{{item.content}}</span>
                  <img @click="goInfo(item.cate.id,item.id)" class="listpic" v-if="item.cover" v-lazy="item.cover">
                  <div v-else>
                    <img @click="goInfo(item.cate.id,item.id)" class="listpic" v-if="item.image&&item.image.length>0" v-lazy="item.image[0]">
                  </div>
                  <div @click="goInfo(item.cate.id,item.id)" v-if="item.video" class="videobox">
                    <img class="listpic" v-lazy="img.default">
                    <img class="videos" :src="img.plays">
                  </div>
                  <van-row type="flex" justify="space-between">
                    <van-col span="20">
                      <span class="binbox" @click="collect(item.post_id,index)">
                        <img class="binpic" :src="item.is_praise?img.collect_have : img.collect">
                        <span class="statenum" v-if="item.praise_num>0">{{item.praise_num}}</span>
                      </span>
                      <span class="binbox" @click="goInfo(item.cate.id,item.id)">
                        <img class="binpic" :src="img.comment">
                        <span class="statenum" v-if="item.comment_num>0">{{item.comment_num}}</span>
                      </span>
                      <span class="binbox" hidden="true">
                        <img class="binpic" :src="img.inrelay">
                        <span class="statenum"></span>
                      </span>
                    </van-col>
                    <van-col class="bintright" span="4" @click="outrelay(item.title,item.content,info.id,info.post_id,item.share_image)">
                      <img class="binpic" :src="img.outrelay">
                    </van-col>
                  </van-row>
                </div>
              </van-col>
            </van-row>
            <van-row v-if="item.cate.id==2">
              <van-col span="6">
               <div class="today" v-if="item.mon!=nowdata&&item.monshow">{{item.mon}}</div>
               <div class="location"></div>
             </van-col>
             <van-col span="18">
              <div class="content">
                <div class="typetime"><span>{{item.cate.type}}</span>-{{item.mon}}</div>
                <p class="title" @click="goInfo(item.cate.id,item.id)"><img class="answtag" :src="img.questionicon">{{item.question}}</p>
                <span class="ellipsis-2 fonts" @click="goInfo(item.cate.id,item.id)">
                  {{item.content}}
                </span>
                <img class="listpic" v-if="item.content.img" v-lazy="item.content.img" @click="showImg(item.content.img)">
                <van-row type="flex" justify="space-between">
                  <van-col span="20">
                    <span class="binbox">
                      <img class="binpic" :src="img.collect">
                      <span class="statenum" v-if="item.praise_num>0">{{item.praise_num}}</span>
                    </span>
                    <span class="binbox" @click="goInfo(item.cate.id,item.id)">
                      <img class="binpic" :src="img.comment">
                      <span class="statenum" v-if="item.comment_num>0">{{item.comment_num}}</span>
                    </span>
                    <span class="binbox" hidden="true">
                      <img class="binpic" :src="img.inrelay">
                      <span class="statenum"></span>
                    </span>
                  </van-col>
                  <van-col class="bintright" span="4" @click="outrelay(item.question,item.content,'/lexus/ask/'+item.id,item.image[0])">
                    <img class="binpic" :src="img.outrelay">
                  </van-col>
                </van-row>
              </div>
            </van-col>
          </van-row>
          <van-row v-if="item.cate.id==3">
            <van-col span="6">
             <div class="today" v-if="item.mon!=nowdata&&item.monshow">{{item.mon}}</div>
             <div class="location"></div>
           </van-col>
           <van-col span="18">
            <div class="content">
              <div class="typetime"><span>{{item.cate.type}}</span>-{{item.mon}}</div>
              <p class="title" @click="goInfo(item.cate.id,item.id)">{{item.question.question}}</p>
              <span class="ellipsis-2 fonts" @click="goInfo(item.cate.id,item.id)" v-if="item.content&&item.content.text"><img class="answtag" :src="img.answericon">{{item.content.text}}</span>
              <img class="listpic" v-if="item.content&&item.content.img" v-lazy="item.content.img" @click="showImg(item.content.img)">
              <van-row type="flex" justify="space-between">
                <van-col span="20">
                  <span class="binbox">
                    <img class="binpic" :src="img.collect">
                    <span class="statenum" v-if="item.praise_num>0">{{item.praise_num}}</span>
                  </span>
                  <span class="binbox" @click="goInfo(item.cate.id,item.id)">
                    <img class="binpic" :src="img.comment">
                    <span class="statenum" v-if="item.comment_num>0">{{item.comment_num}}</span>
                  </span>
                  <span class="binbox" hidden="true">
                    <img class="binpic" :src="img.inrelay">
                    <span class="statenum"></span>
                  </span>
                </van-col>
                <van-col class="bintright" span="4" @click="outrelay(item.question.question,item.content.text,'/lexus/ask/'+item.id+'/answer',item.content.img)">
                  <img class="binpic" :src="img.outrelay">
                </van-col>
              </van-row>
            </div>
          </van-col>
        </van-row>
        <van-row v-if="item.cate.id==4">
          <van-col span="6">
           <div class="today" v-if="item.mon!=nowdata&&item.monshow">{{item.mon}}</div>
           <div class="location"></div>
         </van-col>
         <van-col span="18">
          <div class="content">
            <div class="typetime">
              <span>{{item.cate.type}}</span>
            -11：38</div>
            <!-- <van-tag class="active" type="success">招募中</van-tag> -->
            <p class="title" @click="goInfo(item.cate.id,item.id)">{{item.title}}</p>
            <div class="sourtime mb-10">时间：{{item.start}}---{{item.end}}</div>
            <div class="sourtime mb-10" v-if="item.author">联系人：{{item.author}}</div>
            <!-- <img class="listpic" :src="img.member_bg"> -->
          </div>
        </van-col>
      </van-row>
    </div>
  </van-list>
</div>
<!-- </van-tab> -->
<!-- <van-tab title="话题">
  <div class="content">
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="已加载全部"
    :offset='580'
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="img.loading" />
    </div>
    <div v-for="item in listt"  :key="'listt_' + item.id">
      <router-link :to="{name:'LexusTopicInfo',params:{id:item.id}}">
        <img class="topicpic" v-lazy="item.pic_url">
        <div class="picount">
          <div class="f-12">话题</div>
          <van-divider />
          <div class="f-16 mt-10">#{{item.name}}#</div>
          <div class="f-12 mt-10">{{item.join_num}}人参与，{{item.recom_num}}条内容值得看</div>
        </div>
      </router-link>
    </div>
  </van-list>
</div>
</van-tab> 
<van-tab title="问答">
  <div class="ask">
   <van-list
   v-model="loading"
   :finished="finished"
   finished-text="已加载全部"
   :offset='580'
   @load="onLoad"
   >
   <div slot="loading" class="list-loading">
    <img :src="img.loading" />
  </div>
  <div class="list-box" v-for="item in lista" :key="'lista_' + item.id">
    <div v-if="item.answer">
      <div class="listitle ellipsis-2 conpdd"><router-link :to="{name: 'LexusAskShowAnswer', params: {id: item.answer.id}}" class="c-black">
        <img class="answtag" :src="img.questionicon">
      {{ item.question }}</router-link></div>
      <div class="f-14 ellipsis-4 conpdd">
        <router-link :to="{name: 'LexusAskShowAnswer', params: {id: item.answer.id}}" class="c-black">
          <img class="answtag" :src="img.answericon">
          {{ item.answer.content.text }}
        </router-link>
      </div>
      <div class="pic-box" v-if="item.answer.content.img">
        <img class="pic_thumb" v-lazy="item.answer.content.img" @click="showImg(item.answer.content.img)">
      </div>
      <van-row class="conpdd" type="flex" justify="space-between">
        <van-col span="20">
          <span class="binbox">
            <img class="binpic" :src="img.collect">
            <span class="sourtime" v-if="item.praise_num > 0">{{item.praise_num}}</span>
          </span>
          <span class="binbox">
            <img class="binpic" :src="img.comment">
            <span class="sourtime"></span>
          </span>
          <span class="binbox" hidden="true">
            <img class="binpic" :src="img.inrelay">
            <span class="sourtime">50</span>
          </span>
        </van-col>
        <van-col class="bintright" span="4" @click="outrelay(item.question,item.answer.content.text,'/lexus/ask/'+item.id+'/answer',item.answer.content.img)">
          <img class="binpic" :src="img.outrelay">
        </van-col>
      </van-row>
      <div class="quetype conpdd"> {{item.answer.answer_time}}</div>
    </div>
    <div v-else>
      <div class="listitle listitle2 ellipsis-2">
        <router-link :to="{name: 'LexusAskShow', params: {id: item.id}}" class="c-black">
          <img class="answtag" :src="img.questionicon">
          {{ item.question }}
        </router-link>
      </div>
      <div class="f-14 conpdd">
        <router-link :to="{name: 'LexusAskShow', params: {id: item.id}}" class="c-black">
          {{ item.content }}
        </router-link>
      </div>
      <div class="pic-box" v-if="item.image">
        <img class="pic_thumb" v-lazy="item.image[0]" @click="showImg(item.image[0])">
      </div>
      <van-row class="conpdd" type="flex" justify="space-between">
        <van-col span="14">
          <span class="sourtime">
            <span v-if="item.answer_num > 0">{{ item.answer_num + '个回答' }} </span>
            <span v-if="item.collect_num > 0">{{ item.collect_num + '个收藏' }}</span>
          </span>
        </van-col>
        <van-col class="bintright" span="10">
          <span class="sourtime" @click="goPost(5,item.question,item.id)">
            <span class="c-blue f-14">我要回答</span>
          </span>
        </van-col>
      </van-row>
    </div>
  </div>
</van-list>
</div>
</van-tab>
</van-tabs>-->
</van-pull-refresh>
<van-image-preview
v-model="showState"
:images="images"
lazyLoad
>
</van-image-preview>
<van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @cancel="onCancel" @click-overlay="onCancel">
  <van-divider class="divider">分享</van-divider>
  <van-grid :border='false' :column-num="5">
    <!-- <van-grid-item :icon="img.inrelay" /> -->
    <van-grid-item :icon="img.friends" @click="toShare(2)" />
    <van-grid-item :icon="img.wechat" @click="toShare(1)" />
    <!-- <van-grid-item :icon="img.link" />
      <van-grid-item :icon="img.poster" /> -->
    </van-grid>
  </van-action-sheet>
</div>
</template>
<script>
  import ask from '../../../api/ask';
  import list from '../../../api/bbs';
  import content from '../../../api/content';
  import member from '../../../api/member/memberinfo';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { Tab, Tabs, List, Row, Col, Button, Tag, Grid, GridItem, Image, Icon,ActionSheet,Step, Steps,Divider,NavBar,PullRefresh,Dialog } from 'vant';
  export default {
    data () {
      return {
       params: {
        channel_id:5,
        page: 1,
        size: 4,
        user_id: '',
      },
      param:{
        media_id: 6,
        user_id:'',
        page:1,
        is_follow: 0
      },
      paramst:{
        space_user_id:'',
        page:1,
        size:6
      },
      myparams:{
        media_id: 6,
        user_id: 0
      },
      list:[],
      lista:[],
      listt:[],
      oldlist:[],
      loading: false,
      finished: false,
      isLoading: false,
      active:0,
      steps:0,
      show:false,
      progress:"50%",
      images:[],
      showState:false,
      info:'',
      shareshow:false,
      otherinfo:'',
      img:{
        loading: require('../../../assets/img/loading_lexus.gif'),
        avatar: require('../../../assets/img/lexus/default.png'),
        member_bg: require('../../../assets/img/lexus/my/member_bg.png'),
        camera:require('../../../assets/img/lexus/my/camera.png'),
        collect: require('../../../assets/img/lexus/collect.png'),
        collect_have: require('../../../assets/img/lexus/collect_have.png'),
        comment: require('../../../assets/img/lexus/comment.png'),
        inrelay: require('../../../assets/img/lexus/inrelay.png'),
        outrelay: require('../../../assets/img/lexus/outrelay.png'),
        friends: require('../../../assets/img/lexus/friends.png'),
        wechat: require('../../../assets/img/lexus/wechat.png'),
        link: require('../../../assets/img/lexus/link.png'),
        poster: require('../../../assets/img/lexus/poster.png'),
        honour: require('../../../assets/img/lexus/my/honour.png'),
        honour_have: require('../../../assets/img/lexus/my/honour_have.png'),
        answericon: require('../../../assets/img/lexus/answericon.png'),
        questionicon: require('../../../assets/img/lexus/questionicon.png'),
        videos: require('../../../assets/img/lexus/my/videos.png'),
        default: require('../../../assets/img/default_lexus.png'),
        plays: require('../../../assets/img/lexus/plays.png'),
        member_car: require('../../../assets/img/member_car.png'),
        border_pic:require('../../../assets/img/lexus/border.gif'),
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.param.user,
      source: state => state.param.source
    })
  },
  created () {
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
    this.$appService.isTabbar({state: true})
    let id = this.$route.params.id
    this.param.user_id=id
    this.paramst.space_user_id=id
    this.params.user_id=id
    var date=new Date;
    this.nowyear = date.getFullYear()
    var month = date.getMonth() + 1;  
    var day = date.getDate(); 
    this.nowdata=month+'.'+day
    this.getMyInfo(id)
    this.getUserOther(id)
    this.weburl=process.env.VUE_APP_URL

  },
  activated () {
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
    this.$appService.isTabbar({state: true})
  },
  methods: {
    getMyInfo(id){
      if(localStorage.getItem("user")){
        var luser=JSON.parse(localStorage.getItem("user"))
        var user_id=luser.data.id
        this.myparams.user_id=user_id
      }else{
        this.myparams.user_id=0
      }
      
      member.getMyInfo(id,this.myparams).then(res => {
        if(res.data.state==1){
          this.info=res.data.data
          var params={
            event_code: '个人首页',
            event_id: this.info.username,
            title: this.info.id,
            value: '',
            path: '/Lexus/My/Other.vue',
            user_id: this.user ? this.user.id : 0,
            source: this.source
          }
          common.BurialPoint(params).then(res => {
            if(res.data.state==1){
            }
          })
        }
      })
    },
    getUserOther(id){
      var params={
        user_id:parseInt([id]),
        source:this.source
      }
      member.userOther(params).then(res => {
        if(res.data.state==1){
          this.otherinfo=res.data.data
          var apppar={
            title:res.data.data.username
          }
          this.$appService.changeTitle(apppar)
        }
      })
    },
    post(){
      this.show=true
    },
    onClick(title){
      this.list=[]
      this.oldlist=[]
      this.lista=[]
      this.listt=[]
      this.active=title
      this.loading = false
      this.finished=false
      this.params.page=1
      this.param.page=1
      this.paramst.page=1
      var cc=document.getElementById('id');
      cc.scrollIntoView(false);
    },
    goPost(type,title,id){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
          var params={
            qid:id,
            type:type,
            title:title
          }
          this.$appService.goPost(params)
        } else {
          var params={
            pagetype:1,
            qid:id,
            type:type,
            title:title
          }
          this.$appService.needLogin(params)
        }
      })
    },
    onLoad(){
      if(this.active==0){
        setTimeout(() => {
          member.getSpaceList(this.param,this.myparams.user_id).then(res => {
            if(res.data.state==1){
              this.param.page += 1
              this.total = res.data.data.total
              this.loading = false
              if(res.data.data.data.length == 0) {
                this.finished = true
              }
              this.oldlist.push.apply(this.oldlist, res.data.data.data)
              let list=this.oldlist;
              let topiclist=[];
              let arr=[]
              for(var i=0;i<list.length;i++){
               let year= list[i].year
               let mon= list[i].date

               list[i].year=year
               list[i].mon=mon
             }
             for(var i=0;i<list.length;i++){
              if(i>0){
                if(list[i].year==list[i-1].year){
                  list[i].yearshow=false
                }else{
                  list[i].yearshow=true
                }
                if(list[i].mon==list[i-1].mon){
                  list[i].monshow=false
                }else{
                  list[i].monshow=true
                }
              }else{
                list[i].yearshow=true
                list[i].monshow=true
              }
            }
            this.list= list
          }
        })
        }, 500);
      }else if(this.active==1){
        setTimeout(() => {
          ask.getAnswerList(this.params).then(res => {
            this.lista.push.apply(this.lista, res.data.data.data)
            this.params.page += 1
            this.total = res.data.data.total
            this.loading = false
            if(res.data.data.data.length == 0) {
              this.finished = true
            }
          })
        }, 500);
        
      }else if(this.active==2){
        setTimeout(() => {
          content.getTopicList(this.paramst).then(res => {
            this.listt.push.apply(this.listt, res.data.data.data)
            this.paramst.page += 1
            this.total = res.data.data.total
            this.loading = false
            if(res.data.data.data.length == 0) {
              this.finished = true
            }
          })
        }, 500);
      }
      
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.show=true
    },
    onCancel(){
      this.show=false
    },
    showImg(image){
     var images=[]
     images.push(image)
     this.images=images
     this.showState=true
   },
   goInfo(type,id){
    var params={
      url:'' ,
      isReturn: true 
    }
    if(type==1){
      params.url=this.weburl+'/lexus/bbs/'+id+'?source='+this.source
    }else if(type==2){
      params.url=this.weburl+'/lexus/ask/'+id+'?source='+this.source
    }else if(type==3){
      params.url=this.weburl+'/lexus/ask/'+id+'/answer?source='+this.source
    }else if(type==4){
      params.url=this.weburl+'/lexus/activeinfo/'+id+'?source='+this.source
    } 
    this.$appService.openWebView(params)
  },
  outrelay(title,content,id,post_id,imageUrl){
    var user_id=this.user?this.user.id:0
    this.shareshow=true
    this.sharetitle=title
    this.sharecontent=content
    if(post_id>0){
      this.sharetype=1
      this.shareid=post_id
      this.shareurl='/pages/article/article?scene='+post_id+'-'+user_id
      this.shareweburl=this.weburl+'/lexus/article/'+post_id+'/post?source='+this.source
    }else{
      this.sharetype=2
      this.shareid=id
      this.shareurl='/pages/articleinfo/articleinfo?scene='+id+'-'+user_id
      this.shareweburl=this.weburl+'/lexus/bbs/'+id+'?source='+this.source
    }

    
    
    if(imageUrl){
      this.shareimageUrl=imageUrl
    }else{
      this.shareimageUrl='https://pic.motortime.com/logo/lexus_logo.png'
    }
  },
  toShare(type){
    if(type==1){
      var params={
        type:type,
        title:this.sharetitle,
        content:this.sharecontent,
        url:this.shareurl,
        imageUrl:this.shareimageUrl,
        user_id:this.user.id,
        weburl:this.shareweburl,
        wechatid:'gh_d2c493f1bc41'
      }
      this.shareshow=false
      this.$appService.shareContent(params)
    }else{
      this.$appService.getToken(v => {
        if(v.token) {
          if(this.sharetype==2){
            var para={
              source:9,
              cid:this.shareid,
              user_id:this.user.id
            }
            bbs.getPoster(para).then(res => {
              if(res.data.state == 1) {
                var params={
                  type:type,
                  title:this.sharetitle,
                  content:this.sharecontent,
                  url:this.shareurl,
                  imageUrl:res.data.data.share_url,
                  weburl:this.shareweburl,
                  wechatid:'gh_d2c493f1bc41'
                }
                this.shareshow=false
                this.$appService.isTabbar({state: false})
                this.$appService.shareContent(params)
              }
            })
          }else{
            var para={
              source:9,
              id:this.shareid,
              user_id:this.user.id
            }
            content.getPoster(para).then(res => {
              if(res.data.state == 1) {
                var params={
                  type:type,
                  title:this.sharetitle,
                  content:this.sharecontent,
                  url:this.shareurl,
                  imageUrl:res.data.data.share_url,
                  weburl:this.shareweburl,
                  wechatid:'gh_d2c493f1bc41'
                }
                this.shareshow=false
                this.$appService.isTabbar({state: false})
                this.$appService.shareContent(params)
              }
            })
          }
        }else{
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
    }
  },
  follow(type){
    var type = type == 0 ? 1 : 2
    content.Follow({follow_user_id: this.info.id, type,media_id: 6}).then(res => {
      if(res.data.state == 1) {
        this.info.is_follow=type==1?1:0
        if(type==1){
          this.info.fans_num++
        }else{
          this.info.fans_num--
        }
      }
    })
  },
  collect(postid,index){
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
      } else {
        var params={
          url:'',
          pagetype:0
        }
        this.$appService.needLogin(params)
      }
    })
    if(this.user) {
      let type = this.list[index].is_praise ? 2 : 1;
      if(postid==0){
        list.setPraise({id: this.list[index].id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.list[index].is_praise = 1
              this.list[index].praise_num += 1
            } else {
              this.list[index].is_praise = 0
              this.list[index].praise_num -= 1
            }
          }
        })
      }else{
        content.setPraise({id: this.list[index].post_id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.list[index].is_praise = 1
              this.list[index].praise_num += 1
            } else {
              this.list[index].is_praise = 0
              this.list[index].praise_num -= 1
            }
          }
        })
      }
      
    } else {
      this.$toast('请先登录')
      return false
    }
  },

  myPraise(){
    Dialog.alert({
      title: this.info.username,
      message: '共获得'+this.info.praise_num+'个赞',
      closeOnClickOverlay:true,
      confirmButtonColor:'#ffffff',
      className:'mydialog'
    }).then(() => {

    });
  },
  fans(type){
    var params={
      url:this.weburl+'/lexus/my/otherfanslist/'+this.param.user_id+'?type='+type+'&source='+this.source,
      isReturn: true 
    }
    this.$appService.openWebView(params)
  },
  onRefresh() {
    setTimeout(() => {
      this.isLoading = false;
      this.list=[]
      this.oldlist=[]
      this.lista=[]
      this.listt=[]
      this.loading = false
      this.finished=false
      this.params.page=1
      this.param.page=1
      this.paramst.page=1
      this.onLoad()
    }, 500);
  }
},
components: {
  [Row.name]: Row,
  [Col.name]: Col,
  [Grid.name]: Grid,
  [GridItem.name]: GridItem,
  [List.name]: List,
  [Button.name]: Button,
  [Tabs.name]: Tabs,
  [Tab.name]: Tab,
  [Tag.name]: Tag,
  [Image.name]:Image,
  [Icon.name]:Icon,
  [ActionSheet.name]:ActionSheet,
  [Step.name]:Step,
  [Steps.name]:Steps,
  [Divider.name]:Divider,
  [NavBar.name]:NavBar,
  [PullRefresh.name]:PullRefresh,
  [Dialog.name]:Dialog
}
}
</script>

<style lang="scss">
.other{
  padding-bottom: 60px;
  .hand-img{
    width: 100%;
    height: 280px;
    position: fixed;
    top: 0;
  }
  .van-nav-bar{
    background-color: transparent;
    .van-icon{
      color: #fff;
    }
    .van-nav-bar__title{
      color: #fff;
    }
  }
  .message{
    color: #fff;
    font-size: 12px;
    padding: 0 15px;
    line-height: 2;
    .van-col--6{
      text-align: center;
    }
    .van-tag {
      padding: 5px 10px;
      letter-spacing: 3px;
      border-radius: 1.5px;
    }
    .info{
      width: 100%;
      height: 250px;
      z-index: 99;
      position: relative;
      margin-top: 60px;
      background-color: #fff;
      border-radius: 1.5px;
      box-shadow: 0.053333rem 0.053333rem 0.133333rem rgba(0, 0, 0, 0.05);
      .head{
        width: 60px;
        height: 60px;
        border-radius: 1.5px;
      }
      .head{
        width: 60px;
        height: 60px;
        border-radius: 1.5px;
      }
      .head_box{
       width: 60px;
       height: 60px;
       position:relative;
       padding: 20px;
     }
     .head_border{
       width: 60px;
       height: 60px;
       position:absolute;
       left: 20px;
     }
     .buttonin{
      float: right;
      margin-top: 35px;
      margin-right: 20px;
    }
    .van-button--small{
      height: 24px;
      padding: 0 8px;
      line-height: 20px;
      border-radius: 1px;
      vertical-align: middle;
    }
    .van-button__icon{
      font-size: 10px;
    }
    .van-button__text{
      font-size: 11px;
    }
    .follow{
      vertical-align: super;
    }
    .followd{
      color: #728FC4;
      background: #F3F9FF;
      border-color: #F3F9FF;
    }
  }
}
.van-tabs{
  background-color: #fff;
}
.van-ellipsis{
  font-weight: bold;
}
.ml-20{
  margin-left: 20px;
}
.ml-10{
  margin-left: 10px;
}
.mt-10{
  margin-top: 10px;
}
.mb-10{
  margin-bottom: 10px;
}
.listleft{
  background-color: #fff;
  padding: 15px;
  .years{
    font-size: 18px;
    color: #9a9a9a;
    font-weight: bold;
  }
  .today{
    font-size: 20px;
    font-weight: bold;
    margin-top: 18px;
  }
  .van-col--18{
    border-bottom: 1px solid #f8f8f8;
  }
  .location{
    font-size: 12px;
    color: #9A9A9A;
    margin-top: 10px;
  }

  .relay{
    height: 100px;
    padding: 10px;
    background-color: #F2F6FA;
    .relaytitle{
      font-size: 15px;
      font-weight: bold;
    }
    .relaypic{
      width: 100%;
      height: 100px;
      border-radius: 1.5px;
    }
  }
}
.content{
  .pd-20{
    padding: 0 20px;
  }
  padding: 20px 0;
  .typetime{
    font-size: 12px;
    color: #9A9A9A;
  }
  .title{
    font-size: 15px;
    font-weight: bold;
    letter-spacing: 2px;
  }
  .listpic{
    width: 100%;
    height: 190px;
    border-radius: 1.5px;
    object-fit: cover;
  }
  .videobox{
    position: relative;
  }
  .videos{
    width: 26px;
    height: 26px;
    position: absolute;
    left: 45%;
    top: 40%;
  }
  .activepic{
    width: 100%;
    height: 230px;
  }
  .binbox{
    margin-right:20px;
    .binpic{
      width:15px;
      height:15px;
      margin-right:8px;
      vertical-align: middle;
    }
  }
  .bintright{
    text-align:right;
    .binpic{
      width:15px;
      height:15px;
      margin-right:8px;
      vertical-align: middle;
    }
  }
  .statenum{
    font-size: 13px;
    color: #605C6B;
        // font-weight: bold;
        vertical-align: middle;
      }
      .sourtime{
        font-size: 12px;
        color: #9A9A9A;
      }
      .fonts{
        font-size: 15px;
        margin-bottom: 10px;
      }
      .active{
        padding: 0;
        margin-right: 5px;
      }
      .topicpic{
        width: 100%;
        height: 230px;
      }
      .picount{
        color: #fff;
        margin-top: -35%;
        padding: 10px;
        .mt-10{
          margin-top: 10px;
        }
        .van-divider{
          width: 20%;
        }
      }
    }
    .post{
      width: 90px;
      height: 90px;
      border-radius: 1.5px;
      background-color: #F8F8F8;
      margin-bottom: 20px;
      img{
        width: 30px;
        height: 26px;
        padding: 30px;
      }
    }
    .list-box {
      padding: 15px 0;
      border-bottom: 1px solid #EAEAEA;
      .conpdd{
        padding: 0 15px;
      }
      .quespic{
        width: 22px;
        height: 22px;
        vertical-align: middle;
      }
      .picone{
        width:100%;
        height:105px;
        border-radius:5px;
        object-fit: cover;
      }
      .listitle{
        padding: 0 15px;
        font-size: 16px;
        font-weight:bold;
        line-height: 32px;
        letter-spacing: 1.4px;
        margin: 10px 0;

        &.listitle2 {
          margin-top: 0;
        }
      }
      .quetype{
        font-size: 12px;
        color: #9A9A9A;
        margin-top: 10px;
      }
      .sourtime{
        font-size: 12px;
        color: #9A9A9A;
        .c-blue {
          font-size: 12px;
          color: #728FC4;
          background: #F2F6FA url(../../../assets/img/lexus/listask.png) no-repeat 8px center;
          background-size: 13px auto;
          width: 80px;
          height: 25px;
          line-height: 25px;
          display: inline-block;
          text-align: left;
          padding-left: 25px;
          border-radius: 1px;
          box-sizing: border-box;
        }
      }
      .binpic{
        width:15px;
        height:15px;
        margin-right:8px;
        vertical-align: middle;
      }
      .binbox{
        margin-right:20px;
      }
      .bintright{
        text-align:right;

        .van-button--default {
          color: #F6AB00;
          border: 1px solid #F6AB00;
          width: 60px;
          height: 25px;
          line-height: 25px;
          font-size: 12px;
          padding: 0;
        }
      }
      .pic-box {
        margin-top: 10px;
        .pic_thumb {
          width: 100%;
          height: 230px;
          object-fit: cover;
          display: block;
        }
      }
      .listhand{
        width:45px;
        height:45px;
        border-radius:1.5px;
      }
      .membername{
        font-size: 15px;
        font-weight: bold;
      }

    }
    .van-grid{
      padding: 20px 0;
    }
    .answtag{
      width: 15px;
      height: 15px;
      margin-right: 10px;
      vertical-align: middle;
    }
  }
  .mydialog{
    border-radius: 3px !important;
    .van-dialog__header{
      margin-top: 10px;
    }
    .van-dialog__content{
      height: 80px;
    }
    .van-button--default{
      background-color:#605c6b !important;
    }
  }

</style>
